import { RentaTarifaAgrupada } from "src/shared/helpers/groupRentasTarifasByTarifa"
import DetailRow from "src/shared/components/data-display/Detail/kit/DetailRow/DetailRow"
import DetailText from "src/shared/components/data-display/Detail/kit/DetailText/DetailText"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { capitalize } from "src/shared/helpers/capitalize"

type Props = {
    grupo: RentaTarifaAgrupada
}

const EntradaMotel = ({ grupo }: Props) => {
    const duracion = grupo.tarifa?.grupo_tarifa?.duracion
    const modalidad = grupo.tarifa?.grupo_tarifa?.modalidad

    return (
        <>
            <DetailRow>
                <DetailText type='bold'>
                    {capitalize(modalidad || "")} | {duracion || "-"} horas
                </DetailText>
            </DetailRow>
            {grupo.entradas.map((entry, index) => (
                <DetailRow key={`entry-motel-${index}`}>
                    <DetailText>
                        {duracion || "-"} horas - {formatCurrencyToFixed(entry.subtotales?.precio_unitario || 0)}
                    </DetailText>
                    <DetailText type="bold" textAlign="right" style={{ maxWidth: "90px" }}>
                        {formatCurrencyToFixed(entry.subtotales?.total || 0)}
                    </DetailText>
                </DetailRow>
            ))}
        </>
    )
}

export default EntradaMotel
